import JustifyPersist from '@/domain/justify/domain/justify-persist.entity';
import ContractRuleParameters from './contract-rule-parameters.entity';
import ContractRuleStatus from './contract-rule-status.entity';

export default class ContractRule {
  id: string;

  name: string;

  parameters: ContractRuleParameters[] = [];

  faixas: string;

  status: ContractRuleStatus;

  itemRuleId: string;

  description: string;

  ruleGroupId: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.status = ContractRuleStatus.of(obj.status) || {};
    this.itemRuleId = obj.itemRuleId || '';
    this.ruleGroupId = obj.ruleGroupId || '';
    if (obj.parameters) {
      this.parameters = ContractRuleParameters.ofList(obj.parameters)
        .sort((el: any, elb: any) => el.index - elb.index);
    }
    this.faixas = obj.faixas || '';
    this.description = obj.description || '';
  }

  public static of(obj: any = {}): ContractRule {
    return new ContractRule(obj || {});
  }

  public static ofEnabled(obj: any = {}): ContractRule {
    const contractRule = new ContractRule(obj || {});
    contractRule.status.enabled = true;
    return contractRule
  }

  public static ofList(obj: any[]): ContractRule[] {
    return obj.map(this.of);
  }

  prepareToSend() {
    this.parameters.forEach((el: ContractRuleParameters) => {
      el.validateMoneyFormatValues();
    })
  }

  public isEmpty(): boolean {
    return this.id === '' && this.name === '' && this.parameters.length === 0 && this.faixas === '';
  }

  disable(justify: JustifyPersist) {
    this.status.enabled = false;
    this.status.competenceStart = justify.competenceStart;
    this.status.competenceEnd = justify.competenceEnd;
  }
}
